import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Appqr from '../../components/Appqr';
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { useSpringCarousel } from "react-spring-carousel";
import "./AboutUs.css";
import loader from '../../assests/loader.gif';
import API from '../../Utils/Api';

// const testimonials = [
//   {
//     id: "1",
//     name: "Jasmin",
//     text: "The atmosphere was warm and inviting, and Sam & the team were incredibly friendly and attentive. I was slightly nervous at the start but Sam made sure that everyone feels comfortable.",
//     img: process.env.REACT_APP_BASE_URL + "/assests/images/quote.svg",
//   },
//   {
//     id: "2",
//     name: "Fathima",
//     text: "The singles night was so much fun with more opportunity to mingle and spend as much time chatting to people as you wanted. It was at the singles night I met a very lovely man who I have been happily dating for 4 weeks now.",
//     img: process.env.REACT_APP_BASE_URL + "/assests/images/quote.svg",
//   },
//   {
//     id: "3",
//     name: "Michael",
//     text: "YFMF has been a game-changer for my social life! I met so many wonderful people and made lifelong connections.",
//     img: process.env.REACT_APP_BASE_URL + "/assests/images/quote.svg",
//   },
//   {
//     id: "4",
//     name: "Sophia",
//     text: "A truly unique experience! The environment was so comfortable, and I felt welcomed right away.",
//     img: process.env.REACT_APP_BASE_URL + "/assests/images/quote.svg",
//   },
// ];

/*const sliderData = [
  {
    image: process.env.REACT_APP_BASE_URL +"assests/images/media-1.jpg",
    link: "https://www.irishtimes.com/life-style/2024/02/14/remember-speed-dating-its-back-and-you-have-four-minutes-to-find-love/"
  },
  {
    image: process.env.REACT_APP_BASE_URL +"assests/images/media-2.jpg",
    link: "https://www.independent.ie/life/we-didnt-plan-to-start-a-singles-events-company-i-think-people-are-just-sick-of-dating-apps/a1456097229.html"
  },
  {
    image: process.env.REACT_APP_BASE_URL +"assests/images/media-3.jpg",
    link: "https://www.limerickleader.ie/news/columns-opinion/1603497/ditching-dating-apps-and-going-off-line-new-ways-to-find-love-in-limerick.html"
  }
];*/

const images = [
  "assests/images/ow-img2.jpg",
  "assests/images/ow-img3.jpg",
  "assests/images/ow-img4.jpg",
  "assests/images/ow-img5.jpg",
];

const AboutUs = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const bottomSliderRef = useRef(null);
  
  const settingsnew = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    beforeChange: (oldIndex, newIndex) => setCurrentIndex(newIndex),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '0',
        }
      }
    ]
  };

  const [loading, setLoading] = useState(true);
  const sliderRef = useRef(null);
  const [sliderdata, setSliderdata] = useState([]);
  
  useEffect(() => {
    if (sliderRef.current) {
      console.log("Slider Ref Initialized:", sliderRef.current);
    }
  }, []);

  // Desktop Navigation
  const goToPreviousSlide = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  };

  const goToNextSlide = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };

  const [itemsPerSlide, setItemsPerSlide] = useState(
    window.innerWidth < 768 ? 1 : 2
  );

  useEffect(() => {
    const handleResize = () => {
      setItemsPerSlide(window.innerWidth < 768 ? 1 : 2);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // const { carouselFragment, slideToPrevItem, slideToNextItem } =
  //   useSpringCarousel({
  //     itemsPerSlide,
  //     withLoop: true,
  //     items: testimonials.map((item) => ({
  //       id: item.id,
  //       renderItem: (
  //         <div className="testimonial-box oppo">
  //           <div className="tes-1 flex-grow-1">
  //             <img src={item.img} alt="Quote" className="img-fluid" />
  //             <p>{item.text}</p>
  //           </div>
  //           <div className="tes-2">{item.name}</div>
  //         </div>
  //       ),
  //     })),
  //   });

  useEffect(() => {
    document.title = `About YFMF | Ireland’s Leading Singles Events Ireland`;
    document.getElementById('bodywrap').className = 'about';

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) {
      metaDesc.setAttribute("content", "Your Friend, My Friend bring singles together offline through casual, inclusive events across Ireland — helping people get off dating apps and connect in real life again.");
    }

    /* Start get slider data */
    API.post('get_media')
      .then(response => {
        setLoading(false);
        if (response.data.status === false) {

        } else {

          setSliderdata(response.data.data);
        }
      }).catch(error => {

      });
    /* End get slider data */

  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    vertical: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          vertical: false,
          verticalSwiping: true,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <>
      <Header />
      <div className="hello-worldss d-flex justify-content-center align-items-center">
        {/* Desktop Image */}
        <img
          src={process.env.REACT_APP_BASE_URL + 'assests/images/about-usnew.jpg'}
          alt=""
          className="img-fluid"
        />
      </div>

      <div className="container-fluid owned pb-5">
        <div className="get-miss pt-5">
          <div className="row d-flex align-items-strech g-4">
            {/* Text Section */}
            <div className="col-md-4 od-2 d-flex">
              <div className="get-app d-flex flex-column flex-grow-1 horiz">
                <div className="tired">
                  <h2>OUR STORY</h2>
                  <h4>Irish owned and run by a husband & wife team</h4>
                </div>
                <div className="tired-2 mt-auto">
                  <p className="mb-0 text-start">
                    If you've attended any of our events this year, chances are
                    you've crossed paths with Sam and Eoin. As a husband-wife
                    duo, we're the driving force behind Your Friend, My Friend.
                  </p>
                </div>
              </div>
            </div>

            {/* Image Section */}
            <div className="col-md-8 od-1 d-flex">
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/ow-img.png'}
                alt="Event Promo"
                className="img-fluid eve-img"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid eventss year-op pt-0">
        <div className="row g-3 align-items-stretch">
          <div className="col-md-4 img-col d-flex">
            <img
              src={process.env.REACT_APP_BASE_URL + 'assests/images/google.png'}
              alt="Event"
              className="img-fluid single"
            />
          </div>

          <div className="col-md-4 img-cols d-flex">
            <div className="testimonial-box">
              <div className="tes-1 flex-grow-1">
                <p>
                  Our mission is to foster connections among people in Ireland,
                  whether it's forging romantic relationships or nurturing
                  friendships, all while building a vibrant community
                </p>
                <p>
                  Founded in May 2023, YFMF has already brought together
                  thousands of singles across Ireland through our Speed Dating
                  and Singles Events. We're thrilled to receive heartwarming
                  messages from our attendees sharing their dating success
                  stories and enduring relationships formed at our events.
                </p>
              </div>
              <div className="tes-2">
                <Link to="/upcoming-events" className="btn text-decoration-none">
                  BROWSE EVENTS
                </Link>
              </div>
            </div>
          </div>

          <div className="col-md-4 img-colss d-flex">
            <div className="row w-100 flex-grow-1">
              <div className="col-12 d-flex flex-column">
                <div className="stats-box flex-grow-1 mb-3 d-flex flex-column justify-content-center">
                  <h3>150+</h3>
                  <p>events per year</p>
                </div>
                <div className="stats-box flex-grow-1 mb-3 d-flex flex-column justify-content-center">
                  <img
                    src={process.env.REACT_APP_BASE_URL + 'assests/images/winner.png'}
                    alt="Event"
                    className="img-fluid mb-3 win"
                  />
                  <p>Winner of Top new emerging Business in Ireland 2025</p>
                </div>
                <div className="stats-box flex-grow-1 d-flex flex-column justify-content-center">
                  <h3>100%</h3>
                  <p>sold-out events</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid media position-relative">
        <div className="text-center mb-4">
          <h2>In the media</h2>
          <p>
            Our events have been making headlines. Read all about what we do and
            our success stories!
          </p>
        </div>
        <div className="d-none d-md-block">
          <button className="custom-next" onClick={goToPreviousSlide}>
            <img src={process.env.REACT_APP_BASE_URL + 'assests/images/right-abo.svg'} alt="Previous" className="carousel-con right-arr" />
          </button>
          <button className="custom-prev" onClick={goToNextSlide}>
            <img src={process.env.REACT_APP_BASE_URL + 'assests/images/lef-abo.svg'} alt="Next" className="carousel-con left-arr" />
          </button>
        </div>
        <div className="col-md-12 text-center dudu">
          {sliderdata.length > 0 ? (
            <Slider ref={sliderRef} {...settings}>
              {sliderdata.map((slide, index) => (
                <Link to={slide.link} key={index} target="_blank" className="slide">
                  <img src={slide.image} alt={`Slide ${index + 1}`} className="img-fluid" />
                </Link>
              ))}
            </Slider>
          ) : null}
        </div>
        <div className="d-block d-md-none d-flex align-items-center justify-content-between mt-4">
          <button className="custom-nexts" onClick={goToPreviousSlide}>
            <img src={process.env.REACT_APP_BASE_URL + 'assests/images/right-abo.svg'} alt="Previous" className="carousel-con right-arr" />
          </button>
          <button className="custom-prevs" onClick={goToNextSlide}>
            <img src={process.env.REACT_APP_BASE_URL + 'assests/images/lef-abo.svg'} alt="Next" className="carousel-con left-arr" />
          </button>
        </div>
      </div>

      <div className="container-fluid eventss testimolias">
        <div className="row mb-4">
          <h2>TESTIMONIALS</h2>
          <div className="d-flex justify-content-between align-items-center">
            <div className="heading">YFMF Success Stories & Reviews</div>
          </div>
        </div>

        <div className="row g-4 align-items-stretch testimonial-wrapper">
          <div className="col-12 col-lg-8 d-flex">
            <div className="testimonial-box flex-column flex-md-row gap-4 w-100">
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/jasmin2.png'}
                alt="Jasmin"
                className="img-fluid single new-hair w-50"
              />
              <div className="d-flex flex-column w-50 nova">
                <div className="tes-1 flex-grow-1">
                  <img
                    src={process.env.REACT_APP_BASE_URL + 'assests/images/quote.svg'}
                    alt="Quote"
                    className="img-fluid"
                  />
                  <p>
                    In August 2025 Gráinne nearly skipped a YFMF rooftop event in Cork but went anyways with friends. The icebreaker game led her to Chris, a guy in the red t-shirt she'd been eyeing — they connected, kissed that night, and haven't looked back since. They've traveled together, blended their families, done a Hyrox race, and still going strong.
                  </p>
                </div>
                <div className="tes-2">Gráinne & Kieran</div>
              </div>
            </div>
          </div>

          <div className="col-12 col-lg-4 d-flex">
            <div className="testimonial-box w-100">
              <div className="tes-1 flex-grow-1">
                <img
                  src={process.env.REACT_APP_BASE_URL + 'assests/images/quote.svg'}
                  alt="Quote"
                  className="img-fluid"
                />
                <p>
                  The singles night was so much fun with more opportunity to mingle and spend as much time chatting to people as you wanted. It was at the singles night I met a very lovely man who I have been happily dating for 4 weeks now.
                </p>
              </div>
              <div className="tes-2">Fathima</div>
            </div>
          </div>

          <div className="col-12 col-lg-4 d-flex">
            <div className="testimonial-box w-100">
              <div className="tes-1 flex-grow-1">
                <img
                  src={process.env.REACT_APP_BASE_URL + 'assests/images/quote.svg'}
                  alt="Quote"
                  className="img-fluid"
                />
                <p>
                  The atmosphere was warm and inviting, and Sam & the team were incredibly friendly and attentive. I was slightly nervous at the start but Sam made sure that everyone feels comfortable.
                </p>
              </div>
              <div className="tes-2">Jasmin</div>
            </div>
          </div>

          <div className="col-12 col-lg-8 d-flex">
            <div className="testimonial-box flex-column flex-md-row gap-4 w-100">
              <div className="d-flex flex-column w-50 nova">
                <div className="tes-1 flex-grow-1">
                  <img
                    src={process.env.REACT_APP_BASE_URL + 'assests/images/quote.svg'}
                    alt="Quote"
                    className="img-fluid"
                  />
                  <p>
                    Chris and Ciave met at a YFMF speed dating event in Dublin. The couple are completely smitten — Ciava  calls Chris the love of her life and is so greatful to YFMF for bringing them together. The pair couldn't be happier with how things turned out.
                  </p>
                </div>
                <div className="tes-2">Ciava & Chris</div>
              </div>
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/jasmin3.png'}
                alt="Jasmin"
                className="img-fluid single new-hair w-50"
              />
            </div>
          </div>
        </div>
      </div>

      {/* <div className="container-fluid eventss testimolias">
        <div className="row mb-4">
          <h2>TESTIMONIALS</h2>
          <div className="d-flex justify-content-between align-items-center">
            <div className="heading">What people are saying about YFMF</div>
            <div className="arros d-none d-md-block">
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/carousel-left.svg'}
                alt="Previous"
                className="img-fluid carousel-control left-arrow"
                onClick={slideToPrevItem}
                style={{ cursor: "pointer" }}
              />
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/carousel-right.svg'}
                alt="Next"
                className="img-fluid ms-3 carousel-control right-arrow"
                onClick={slideToNextItem}
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>
        </div>

        <div className="row g-3 align-items-stretch testimonial-wrapper">
          <div className="col-md-4 img-col d-flex testimonial-image">
            <img
              src={process.env.REACT_APP_BASE_URL + 'assests/images/jasmin.png'}
              alt="Jasmin"
              className="img-fluid single"
            />
          </div>
          <div className="col-md-8 overflow-hidden testimonial-text">
            {carouselFragment}
          </div>
        </div>

        <div className="d-block d-md-none mt-4">
          <div className="arros d-flex align-items-center justify-content-between">
            <img
              src={process.env.REACT_APP_BASE_URL + 'assests/images/carousel-left.png'}
              alt="Previous"
              className="img-fluid carousel-control left-arrow"
              onClick={slideToPrevItem}
              style={{ cursor: "pointer" }}
            />
            <img
              src={process.env.REACT_APP_BASE_URL + 'assests/images/carousel-right.png'}
              alt="Next"
              className="img-fluid ms-3 carousel-control right-arrow"
              onClick={slideToNextItem}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
      </div> */}

      {/* <div className="container-fluid ireland new-real new">
        <div className="row g-4">
          <div className="col-md-6 ire-left">
            <p>WORK WITH US</p>
            <h2>Brand Partnerships & Collaborations</h2>
          </div>

          <div className="col-md-6 ire-right">
            <p>
              We believe in creating events that not only bring singles together
              but also showcase the best our cities have to offer. That’s why
              we’re excited to partner with brands and venues that share our
              passion for building meaningful connections.
            </p>
            <div className="arrive">
              <Link
                to="/contact"
                className="btn bros-bu text-decoration-none"
              >
                GET IN TOUCH
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid expand new-real new">
        <div className="row align-items-strech d-flex">
          <div className="col-md-6 d-flex flex-column justify-content-between">
            <div className="tired">
              <h2>PARTNERSHIP</h2>
              <h4>Why Partner with YFMF?</h4>
            </div>
            <div className="tired-2">
              <Link
                to="/contact"
                className="brow-bu text-decoration-none d-none d-md-inline-block"
              >
                GET IN TOUCH
              </Link>
            </div>
          </div>

          <div className="col-md-6 d-flex flex-column">
            <div className="d-flex flex-grow-1 gap-3 locat">
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/brand-1.svg'}
                alt="Previous"
                className="img-fluid"
              />
              <div>
                <h5>Expand Your Reach</h5>
                <p>
                  Introduce your brand to a vibrant audience of sociable, active
                  individuals.
                </p>
              </div>
            </div>
            <div className="d-flex flex-grow-1 gap-3 locat">
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/brand-2.svg'}
                alt="Previous"
                className="img-fluid"
              />
              <div>
                <h5>Boost Engagement</h5>
                <p>
                  Connect directly with attendees through event sponsorships,
                  product placements, and activations.
                </p>
              </div>
            </div>
            <div className="d-flex flex-grow-1 gap-3 locat">
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/brand-3.svg'}
                alt="Previous"
                className="img-fluid"
              />
              <div>
                <h5>Local Impact</h5>
                <p>
                  Collaborate with us to create memorable experiences while
                  highlighting your venue or brand’s unique character.
                </p>
              </div>
            </div>
            <div className="d-flex flex-grow-1 gap-3 locat locats">
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/brand-4.svg'}
                alt="Previous"
                className="img-fluid"
              />
              <div>
                <h5>Creative Opportunities</h5>
                <p>
                  From co-branded events to exclusive sponsorships, we’re open
                  to ideas that bring value to everyone involved.
                </p>
              </div>
            </div>
          </div>

          <div className="d-flex d-md-none order-4 tired-2 mt-3 text-center">
            <Link
              to="/contact"
              className="brow-bu text-decoration-none w-100"
            >
              GET IN TOUCH
            </Link>
          </div>
        </div>
      </div>

      <div className="container-fluid real-connection new-real">
        <div className="row justify-content-between">
          <div className="col-md-4 d-flex flex-column justify-content-between">
            <div className="slidees ols">
              <h6>PARTNERSHIP</h6>
              <h2>"Send Love" – A Valentine’s Partnership with An Post</h2>
              <p>
              For Valentine’s Day, Your Friend, My Friend partnered with An Post to create “Send Love”, a unique event blending fitness and meaningful connections. During a 5KM Singles Run Club, participants stopped along the route to write and send a personalised postcard to a loved one, courtesy of An Post. After the run, singles gathered at a local coffee shop for coffee, treats, and conversation. With over 80 singles participating and hundreds of postcards sent across Ireland, the campaign reinforced An Post’s message of connection while generating strong brand engagement through social media and word-of-mouth.
              </p>
            </div>
            <div className="d-none d-md-flex justify-content-start">
              <button
                className="btn"
                onClick={() => bottomSliderRef.current.slickPrev()}
              >
                <div className="arrow-container">
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-left.png"
                    }
                    className="img-fluid arrow-image arrow-image-1"
                    alt="Previous"
                  />
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-left-hover.png"
                    }
                    className="img-fluid arrow-image arrow-image-2"
                    alt="Previous Hover"
                  />
                </div>
              </button>
              <button
                className="btn"
                onClick={() => bottomSliderRef.current.slickNext()}
              >
                <div className="arrow-container">
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-right.png"
                    }
                    className="img-fluid arrow-image arrow-image-1"
                    alt="Next"
                  />
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-right-hover.png"
                    }
                    className="img-fluid arrow-image arrow-image-2"
                    alt="Next Hover"
                  />
                </div>
              </button>
            </div>
          </div>

          <div className="col-md-8 pe-md-0">
            <div className="slidexoxo">
              <Slider ref={bottomSliderRef} {...settingsnew}>
                {images.map((img, i) => (
                  <div key={i} className={`custom-slide ${ i === images.length - 1 ? 'last-slide' : '' } ${i === currentIndex + 1 ? 'second-visible' : ''}`} >
                    <img
                      src={process.env.REACT_APP_BASE_URL + img}
                      className="img-fluid respo"
                      alt={`Slide ${i}`}
                      style={{ width: "100%", height: "600px", borderRadius: 24, objectFit: "cover" }}
                      onError={(e) => (e.target.style.display = "none")}
                    />
                  </div>
                ))}
              </Slider>
            </div>
          </div>

          <div className="col-12 d-flex d-md-none justify-content-between mt-3 p-0">
            <button
              className="btn"
              onClick={() => bottomSliderRef.current.slickPrev()}
            >
              <div className="arrow-container">
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-left.png"
                  }
                  className="img-fluid arrow-image arrow-image-1"
                  alt="Previous"
                />
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-left-hover.png"
                  }
                  className="img-fluid arrow-image arrow-image-2"
                  alt="Previous Hover"
                />
              </div>
            </button>
            <button
              className="btn"
              onClick={() => bottomSliderRef.current.slickNext()}
            >
              <div className="arrow-container">
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-right.png"
                  }
                  className="img-fluid arrow-image arrow-image-1"
                  alt="Next"
                />
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-right-hover.png"
                  }
                  className="img-fluid arrow-image arrow-image-2"
                  alt="Next Hover"
                />
              </div>
            </button>
          </div>
        </div>
      </div> */}

      {loading && (
        <div className="loadingClass">
          <img src={loader} alt="loader" />
        </div>
      )}
      <Appqr />
      <Footer />
    </>
  );
};

export default AboutUs;
